export default [
  {
    path: "/reportes-permisos",
    name: "reportes-permisos",
    component: () => import(/* webpackChunkName: "reportes-permisos" */ "./index.vue"),
  },
 
];
